import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Form, Formik } from 'formik';

import { SecurityService } from 'service/SecurityService';
import FormikTextField from 'components/InputsField/formikInputs/FormikTextField';
import PopupTitle from 'components/common/PopupTitle';
import Button from 'components/common/Button';
import Error from 'components/Forms/Error';
import Loading from '../../Loading';
import { emailValidation } from './validate';

import styles from './styles.module.scss';
import { ERROR_PLACE } from 'components/InputsField/InputError';

const INITIAL_VALUES = {
  email: '',
};

const PasswordReset = () => {
  const { t } = useTranslation();

  const lang = useSelector((state) => state.settings.lang);

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState('');

  const handleSubmit = (values) => {
    setLoading(true);
    setSuccess(false);
    setError('');

    SecurityService.forgot({ email: values.email, lang })
      .then(() => {
        setSuccess(true);
      })
      .catch((e) => {
        setError(e.response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderError = () => {
    let message = '';

    if (error) {
      if (error.status === 409) {
        message = t('forgot_password.linkAlreadyGenerated');
      } else if (error.status === 404) {
        message = t('forgot_password.notFound');
      } else {
        message = t('forgot_password.error');
      }
    }

    return message;
  };

  return (
    <div className="login__wrapper">
      <PopupTitle title={t('forgot_password.heading')} />
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={emailValidation(t)}
        onSubmit={handleSubmit}
      >
        <Form>
          <ul className="login__list">
            <li className={styles.field}>
              <FormikTextField
                name="email"
                maxLength="64"
                label={t('forgot_password.enter_email')}
                type="email"
                required
                errorMode={ERROR_PLACE.static}
              />
            </li>
            {success && (
              <li className="popup__item">
                <span className="popup__success-message">{t('forgot_password.success')}</span>
              </li>
            )}
            <li className="popup__item">
              {loading ? (
                <Loading />
              ) : (
                <Button className={styles.button} type="submit">{t('forgot_password.reset_button')}</Button>
              )}
            </li>
          </ul>
        </Form>
      </Formik>
      {error && (
        <div className={styles.error}>
          <Error>{renderError()}</Error>
        </div>
      )}
    </div>
  );
};

export default PasswordReset;
